export default __webpack_public_path__ + "static/media/infinityQs.937a699a.png";